// The real reason a payout did not go through, in order of how close it is to
// what the payment partner actually said.
export function realCause(payout) {
  const m = payout?.metadata || {};
  return (
    payout?.handledBy?.failureReason ||
    m.provider_failure_reason ||
    m.last_retry_error ||
    m.decline_reason ||
    null
  );
}

// Which partner handled the payout (null when it never reached one).
export function handledByProvider(payout) {
  return payout?.handledBy?.provider || null;
}

// What the customer was told (one of a fixed list of messages).
export function customerMessage(payout) {
  return payout?.statusMessage || null;
}

// Where the cause above came from, so a thin one is not mistaken for the
// partner's own words.
export function causeNote(payout) {
  const m = payout?.metadata || {};
  if (payout?.handledBy?.failureReason) return "From the partner that handled it";
  if (m.provider_failure_reason) return "From the payment partner";
  if (m.last_retry_error) return "From the last retry";
  if (m.decline_reason) return "Our note (the partner's own text was not saved)";
  return "No cause recorded";
}
